// extracted by mini-css-extract-plugin
module.exports = {"content":"Criteria_content__YfW2W"};